export type RenewProductMessages = {
  safeBuyLabel: string;
  signatureLabel: string;
  totalLabel: string;
  renewalLabel: string;
  additionalFeeLabel: string;
  perOrderLabel: string;
  additionalFeesLabel: string;
  feePerOrderText: string;
  feePerConversationText: string;
  totalPerEventValueLabel: string;
  totalFeePerSalesConvertionValueLabel: string;
  totalSalesConvertionValueLabel: string;
};

export const RENEW_PRODUCT_MESSAGES: RenewProductMessages = {
  safeBuyLabel: "Compra segura",
  signatureLabel: "Assinatura:",
  totalLabel: "Total:",
  renewalLabel: "Renovação do plano contratado",
  additionalFeeLabel: "Taxa adicional:",
  perOrderLabel: "por pedido",
  additionalFeesLabel: "Taxas adicionais:",
  feePerOrderText: "por pedido",
  feePerConversationText: "por conversa",
  totalPerEventValueLabel: "Total sobre eventos:",
  totalFeePerSalesConvertionValueLabel: "Total sobre vendas:",
  totalSalesConvertionValueLabel: "Total sobre quantidade de vendas:",
};
